<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <button type="button" id="btnPopupDT" class="btn btn-block btn-primary float-sm-right" (click)="showInfoPopUp()" style="display:none">POP-UP</button>
       
        <button type="button" id="btnLoadList" (click)="getArticleList()" style="display:none">Get</button>
        <button type="button" id="btnRefreshLoadData" (click)="getArticleList(true,false)" style="display:none">Get</button>

        <div class="divContainer">
          <button type="button" id="btnGetVolumeIssues" (click)="getVolumeIssue()" style="display:none">GetVolumeIssue</button>
          <div class="col-sm-12" id="divMainFilter" style="padding:10px">
            <div class="row">
              <div class="col-sm-6">
                <label>Journals</label>
                <select id="lstJournals" class="form-control" multiple onchange="$('#btnGetVolumeIssues').trigger('click');">
                  <option *ngFor="let item of journalList" value={{item.ID}}>
                    {{item.Acronym}}
                  </option>
                </select>
              </div>
              <div class="col-sm-2">
                <label>Volume</label>
                <select id="lstVolume" class="form-control">
                  <option selected value="0">All</option>
                  <option *ngFor="let item of volumeList" value={{item.ID}}>
                    {{item.Volume}}
                  </option>
                </select>
              </div>
              <div class="col-sm-2">
                <label>Issue</label>
                <select id="lstIssue" class="form-control">
                  <option selected value="0">All</option>
                  <option *ngFor="let item of issueList" value={{item.ID}}>
                    {{item.Issue}}
                  </option>
                </select>
              </div>
              <div class="col-sm-2">
                <label>Status</label>
                <select id="ddlStatus" class="form-control select2">
                  <option value="All" selected="selected">All</option>
                  <option *ngFor="let item of lStatusList" value={{item.Activity}}>
                    {{item.Activity}}
                  </option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-2">
                <label>Date Field</label>
                <select id="ddlField" class="form-control select2">
                  <option value="All" selected="selected">All</option>
                  <option value="ReceivedDate">Prd Start Date</option>
                  <option value="EPubDate">EPub Date</option>
                </select>
              </div>
              <div class="col-sm-2">
                <label>From</label>
                <input id="Txt_FromDate" type="Date" class="form-control" autocomplete="off">
              </div>
              <div class="col-sm-2">
                <label>To</label>
                <input id="Txt_ToDate" type="Date" class="form-control" autocomplete="off">
              </div>
              <div class="col-sm-1" style="display:none">
                <label>Data Field</label>
                <select id="ddlDataField" class="form-control select2">
                  <option value="All" selected="selected">All</option>
                  <option value="PressPak">PressPak</option>
                  <option value="L1Request">L1 Request</option>
                  <option value="SpecialCollection">Special Collection</option>
                  <option value="SpecialIssue">Special Issue</option>
                  <option value="Cover">Cover</option>
                  <option value="FeatureArticle">Feature Article</option>
                </select>
              </div>
              <div class="col-sm-1">
                <label>PressPak</label>
                <select id="ddlPressPak" class="form-control select2">
                  <option value="All" selected="selected">All</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>
              <div class="col-sm-4">
                <button type="button" class="btn btn-outline-info waves-effect waves-light clsMargin" title="Get" (click)="getFiltered()">Search</button>
                <button type="button" class="btn btn-outline-danger waves-effect waves-light clsMargin" title="Clear" (click)="resetFilter()" style="margin-left:10px">Reset</button>
              </div>
            </div>
          </div>

          <table #dataTable class="display" style="width:100%;"></table>
        </div>

        <app-articlemonitorinfo></app-articlemonitorinfo>

      </div>
    </div>
  </div>
</div>
